<!--系统介绍-->
<template>
  <el-row id="wrap" class="hei100 overauto">
    <el-row id="topbar" style="padding-top:34px;padding-bottom:0;" :class="scrollH>=80?'bgc-wt boxshadow':''">
      <el-row>
        <div class=" absolute" style="left:0px;top:14px;">
          <div class=" pointer" :class="scrollH>=80?'reback':'reback2'" @click="backUrl()"><span>返回首页</span></div>
        </div>
        <el-row class="auto text-center" :class="scrollH>=80?'company-menu':'company-menu2'" style="width:1500px;"
          type="flex" justify="space-between">
          <div class="" :class="Calink==1?'onclick':''" @click="Calink=1">
            <span>路面养护科学决策辅助系统</span>
          </div>
          <div class="" :class="Calink==2?'onclick':''" @click="Calink=2">
            <span>路面养护智能管理系统</span>
          </div>
          <div class="" :class="Calink==3?'onclick':''" @click="Calink=3">
            <span>桥梁养护智能管理系统</span>
          </div>
          <div class="" :class="Calink==4?'onclick':''" @click="Calink=4">
            <span>智慧工地管控云平台</span>
          </div>
          <div class="" :class="Calink==5?'onclick':''" @click="Calink=5">
            <span>桥梁定期检测系统</span>
          </div>
          <div class="" :class="Calink==6?'onclick':''" @click="Calink=6">
            <span>公路工程材料试验检测系统</span>
          </div>
          <div class="" :class="Calink==7?'onclick':''" @click="Calink=7">
            <span>路面技术状况智能管理系统</span>
          </div>
        </el-row>
      </el-row>
    </el-row>
    <!--  -->
    <el-row class="flexson" style="">      
        <div v-show="Calink==1">
          <img class="block wid100" src="../../assets/part1/s1.png" alt="">
          <img class="block wid100" src="../../assets/part1/s11.jpg" alt="">
          <img class="block wid100" src="../../assets/part1/s12.jpg" alt="">
          <img class="block wid100" src="../../assets/part1/s13.jpg" alt="">
        </div>
        <div v-show="Calink==2">
          <img class="block wid100" src="../../assets/part1/s2.png" alt="">
          <img class="block wid100" src="../../assets/part1/s21.jpg" alt="">
          <img class="block wid100" src="../../assets/part1/s22.jpg" alt="">
          <img class="block wid100" src="../../assets/part1/s23.jpg" alt="">
        </div>
        <div v-show="Calink==3">
          <img class="block wid100" src="../../assets/part1/s3.png" alt="">
          <img class="block wid100" src="../../assets/part1/s31.jpg" alt="">
          <img class="block wid100" src="../../assets/part1/s32.jpg" alt="">
          <img class="block wid100" src="../../assets/part1/s33.jpg" alt="">
        </div>
        <div v-show="Calink==4">
          <img class="block wid100" src="../../assets/part1/s4.png" alt="">
          <img class="block wid100" src="../../assets/part1/s41.jpg" alt="">
          <img class="block wid100" src="../../assets/part1/s42.jpg" alt="">
          <img class="block wid100" src="../../assets/part1/s43.jpg" alt="">
        </div>
        <div v-show="Calink==5">
          <img class="block wid100" src="../../assets/part1/s5.png" alt="">
          <img class="block wid100" src="../../assets/part1/s51.jpg" alt="">
          <img class="block wid100" src="../../assets/part1/s52.jpg" alt="">
          <img class="block wid100" src="../../assets/part1/s53.jpg" alt="">
        </div>
        <div v-show="Calink==6">
          <img class="block wid100" src="../../assets/part1/s6.png" alt="">
          <img class="block wid100" src="../../assets/part1/s61.jpg" alt="">
          <img class="block wid100" src="../../assets/part1/s62.jpg" alt="">
          <img class="block wid100" src="../../assets/part1/s63.jpg" alt="">
        </div>
        <div v-show="Calink==7">
          <img class="block wid100" src="../../assets/part1/s7.png" alt="">
          <img class="block wid100" src="../../assets/part1/s71.jpg" alt="">
          <img class="block wid100" src="../../assets/part1/s72.jpg" alt="">
          <img class="block wid100" src="../../assets/part1/s73.jpg" alt="">
        </div>      
        
      
    </el-row>
    <footerbar></footerbar>
  </el-row>
</template>

<script>
import footerbar from "../footerbar";
export default {
  name: "sysinfo",
  components: { footerbar },
  data() {
    return {
      Calink: 1,
      scrollH:0,
    };
  },
  mounted() {
    document.querySelector("#wrap").addEventListener('scroll',this.handleScroll)  
    this.Calink = this.$route.query.onindex;
    console.log(this.Calink)
  },
  methods: {
    backUrl(){
      this.$router.push({path:'/index'})
    },
    handleScroll(){
      let scrollTop = document.querySelector("#wrap").scrollTop;
      this.scrollH = scrollTop;      
    },   
    pushTorczp() {
      this.$router.push({ path: "/joinUs" });
    }
  },
  destroyed() {},
  watch: {

  }
};
</script>



// WEBPACK FOOTER //
// src/components/basicData/sysinfo.vue